/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ApprovalRequestSummary,
  ApprovalRequestSummary$inboundSchema,
} from "./approvalrequestsummary.js";

/**
 * A page of the approval queue.
 */
export type ListApprovalRequestsResult = {
  /**
   * The list of approval requests
   */
  requests: Array<ApprovalRequestSummary>;
};

/** @internal */
export const ListApprovalRequestsResult$inboundSchema: z.ZodMiniType<
  ListApprovalRequestsResult,
  unknown
> = z.object({
  requests: z.array(ApprovalRequestSummary$inboundSchema),
});

export function listApprovalRequestsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListApprovalRequestsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListApprovalRequestsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListApprovalRequestsResult' from JSON`,
  );
}
